const pickingListRowStatus = {
	None: 0,
	Picked: 1,
	NotFound: 2,
}
export default pickingListRowStatus
